import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { forkJoin } from 'rxjs';
import { City, State } from 'src/app/core/Models/interfaces/responseData';

@Component({
  selector: 'app-company-address',
  templateUrl: './company-address.component.html',
  styleUrls: ['./company-address.component.css']
})
export class CompanyAddressComponent implements OnInit {
  showAddress: boolean = true;
  @Input() formGroupName!: string;
  addressForm!: FormGroup;
  countryList: any[] = [];
  stateList: any[] = [];
  @Input() submitted: boolean = false;
  @Input('uniQueId') uniQueId:number = 1;
  @Input('isThirdPartyComp') isThirdPartyComp: boolean = false;
  @Input() states:State[]=[];
  @Input() city:City[]=[];
  public cityList: City[] = [];
  constructor(
    private rootFormGroup: FormGroupDirective,
    private provPayerApiService: ProvPayerApiService
  ) { }

  ngOnInit(): void {
    this.addressForm = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.getMasterLists();
    if(this.states?.length){
      this.stateList = this.states;
    }
    if(this.city?.length) this.cityList = this.city;
  }
  getMasterLists() {
    forkJoin([
      this.provPayerApiService.getCountryList(),
    ]).subscribe({
      next: (responseList) => {
        this.countryList = responseList[0];
      }
    })
  }

  getStateList(event:any) {
    if(event?.value != null){
    if (this.addressForm.value.country.countryId) {
      let selectedCountryId = this.addressForm?.value?.country?.countryId;
      this.provPayerApiService.getStateList(selectedCountryId).subscribe({
        next: (response) => {
          if (response) {
            this.addressForm.controls['stateList'].setValue(response?.data);
          }
        },
        error: (error) => {
          // treat error
        },
      })
    }
  }else{
    this.addressForm?.controls['state']?.patchValue(null);
    this.addressForm.controls?.['area']?.patchValue(null);
    this.stateList=[];
    this.cityList=[];
  }
  }
  getCityList(event:any) {
    if(event?.value == null){
      this.addressForm.controls?.['area']?.patchValue(null);
      this.cityList=[];
    }
    if (this.addressForm?.value?.state?.regionId) {
      let stateId = this.addressForm?.value?.state?.regionId;
      this.provPayerApiService.getCityList(stateId).subscribe({
        next: (response) => {
          if (response) {
            this.addressForm.controls['cityList'].setValue(response?.data);
          }
        },
        error: (error) => {
          // treat error
        },

      })
      this.setAreaGeoCode();
    }
  }
  setAreaGeoCode(){
    let aCode = this.addressForm.controls?.['area']?.value?.codes[0]?.postalCode;
    let gCode = this.addressForm.controls?.['area']?.value?.codes[0]?.geoCode
    this.addressForm.patchValue({
      areaCode: aCode,
      geoCode: this.addressForm.value.area?.codes[0].geoCode
    })
    
  }
}


